document.getElementById('menu-toggle').addEventListener('click', (e) => {
	e.preventDefault();
	e.stopPropagation();
	if (document.body.classList.contains('responsive-menu-open')) {
		document.body.classList.remove('responsive-menu-open');
	} else {
		document.body.classList.add('responsive-menu-open');
	}
});

document.querySelector('.toggle-responsive-search-js').addEventListener('click', (e) => {
	e.preventDefault();
	e.stopPropagation();
	if (document.body.classList.contains('search-responsive-open')) {
		document.body.classList.remove('search-responsive-open');
	} else {
		document.body.classList.add('search-responsive-open');
		document.querySelector('.responsive-search-input').focus();
	}
});

document.querySelector('.main-menu').addEventListener('click', (e) => {
	e.stopPropagation();
});

document.querySelector('.toggle-authentication-overlay-js').addEventListener('click', (e) => {
	e.preventDefault();
	e.stopPropagation();
	if (document.body.classList.contains('authentication-overlay-visible')) {
		document.body.classList.remove('authentication-overlay-visible');
	} else {
		document.body.classList.add('authentication-overlay-visible');
	}
});

document.body.addEventListener('click', () => {
	const bodyClasses = document.body.classList;
	bodyClasses.remove('authentication-overlay-visible');
	bodyClasses.remove('responsive-menu-open');
	bodyClasses.remove('forgot-password-overlay-visible');
});

document.querySelector('.authentication-overlay').addEventListener('click', (e) => {
	e.stopPropagation();
});

if (document.querySelector('.forgot-password-link-js')) {
	document.querySelector('.forgot-password-link-js').addEventListener('click', (e) => {
		e.preventDefault();
		e.stopPropagation();
		const bodyClasses = document.body.classList;
		bodyClasses.add('forgot-password-overlay-visible');
	});
}

if (document.querySelector('.infobox-link-js')) {
	const infoLinks = Array.from(document.querySelectorAll('.infobox-link-js'));
	infoLinks.forEach((link) => {
		const linkId = link.id;
		const contentId = link.dataset.tippyContent;
		if (linkId !== undefined && contentId !== undefined) {
			tippy(`#${linkId}`, {
				html: `#${contentId}`, // OR document.querySelector('#my-template-id')
				arrow: false,
				animation: 'fade',
				offset: 100,
				duration: 350,
				position: 'bottom-start',
			});
		}
	});
}

// tippy('#tippy-personal-info', {
// 	html: '#tippy-personal-info-content', // OR document.querySelector('#my-template-id')
// 	arrow: false,
// 	animation: 'fade',
// 	offset: 100,
// 	duration: 350,
// 	position: 'bottom-start',
// });

// tippy('#tippy-forgot-password', {
// 	html: '#tippy-forgot-password-content', // OR document.querySelector('#my-template-id')
// 	arrow: false,
// 	animation: 'fade',
// 	offset: 100,
// 	duration: 350,
// 	position: 'bottom-start',
// });
